export enum LocaleCodes {
  EN = 'en',
  ES = 'es',
}
export const Locales = {
  [LocaleCodes.EN]: 'English' as const,
  [LocaleCodes.ES]: 'Spanish' as const,
};
